/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Start function request type
 */
export class StartFunctionRequestModel { 
    /**
     * ADRE SessionID returned in one of the ValidateUser services
     */
    SessionID: number;
    /**
     * The FunctionType enumerations for the currently supported internal functions are: RenewIndividualLicense = 1,  RenewEntityLicense = 12, SeverEmployment = 8, SeverTransferEmployees = 10, SubmitBrokerAuditDeclaration = 9, ViewIndividualPendingTransactions = 4, ViewIndividualTransactionHistory = 7, ViewBrokerTransactionHistory = 6,  ViewPendingBrokerApprovals = 5
     */
    FunctionType: StartFunctionRequestModel.FunctionTypeEnum;
}
export namespace StartFunctionRequestModel {
    export type FunctionTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 25 | 26 | 27 | 28 | 29 | 30 | 31 | 32 | 33 | 34;
    export const FunctionTypeEnum = {
        NUMBER_1: 1 as FunctionTypeEnum,
        NUMBER_2: 2 as FunctionTypeEnum,
        NUMBER_3: 3 as FunctionTypeEnum,
        NUMBER_4: 4 as FunctionTypeEnum,
        NUMBER_5: 5 as FunctionTypeEnum,
        NUMBER_6: 6 as FunctionTypeEnum,
        NUMBER_7: 7 as FunctionTypeEnum,
        NUMBER_8: 8 as FunctionTypeEnum,
        NUMBER_9: 9 as FunctionTypeEnum,
        NUMBER_10: 10 as FunctionTypeEnum,
        NUMBER_11: 11 as FunctionTypeEnum,
        NUMBER_12: 12 as FunctionTypeEnum,
        NUMBER_13: 13 as FunctionTypeEnum,
        NUMBER_14: 14 as FunctionTypeEnum,
        NUMBER_15: 15 as FunctionTypeEnum,
        NUMBER_16: 16 as FunctionTypeEnum,
        NUMBER_17: 17 as FunctionTypeEnum,
        NUMBER_18: 18 as FunctionTypeEnum,
        NUMBER_19: 19 as FunctionTypeEnum,
        NUMBER_25: 25 as FunctionTypeEnum,
        NUMBER_26: 26 as FunctionTypeEnum,
        NUMBER_27: 27 as FunctionTypeEnum,
        NUMBER_28: 28 as FunctionTypeEnum,
        NUMBER_29: 29 as FunctionTypeEnum,
        NUMBER_30: 30 as FunctionTypeEnum,
        NUMBER_31: 31 as FunctionTypeEnum,
        NUMBER_32: 32 as FunctionTypeEnum,
        NUMBER_33: 33 as FunctionTypeEnum,
        NUMBER_34: 34 as FunctionTypeEnum
    };
}



// WEBPACK FOOTER //
// ./src/app/model/startFunctionRequestModel.ts